import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
// import validator from 'validator';
import { postNewsLetter } from "../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../utils";
import { IoIosArrowRoundForward } from "react-icons/io";
import { CURRENT_YEAR, DOMAIN_NAME, FACEBOOK_URL, INSTAGRAM_URL, TWITTER_URL } from "../../../configs/AppConfig";
// import NewsletterPopup from "../pages/NewsletterPopup";

import { TbHours24 } from "react-icons/tb";
import { LiaCalendarWeekSolid } from "react-icons/lia";
import { GrSecure } from "react-icons/gr";
// import { MdOutlineSecurity } from "react-icons/md";
import { IoMdSpeedometer } from "react-icons/io";

import guestportal from "../../../assets/guestportal.css";


function GuestFooter() {
    const [email, setEmail] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [isScrollShow, setIsScrollShow] = useState(false);
    const canvasRef = useRef(null);
    const animationFrameRef = useRef(null);

    let errorsObj = { email: '' };
    const [errors, setErrors] = useState(errorsObj);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 400) {
            setIsScrollShow(true);
        } else {
            setIsScrollShow(false);
        }
    };
    window.addEventListener('scroll', toggleVisible);

    const handleScroll = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const onSubmitNewsLetter = (e) => {
        e.preventDefault();

        // Reset errors
        setErrors({ email: '' });

        // Custom validation
        let errorObj = { email: '' };
        let error = false;

        if (!email) {
            errorObj.email = 'Please Enter Email';
            error = true;
        } else if (!validateEmail(email)) {
            errorObj.email = 'Please enter a valid email address';
            error = true;
        }
        if (error) {
            setErrors(errorObj);
            return;
        }

        setIsDisabled(true);

        const obj = {
            email: email
        };

        postNewsLetter(obj)
            .then(response => {
                setIsDisabled(false);
                setEmail('');
                toast.success(response.data.message);
            })
            .catch(err => {
                setIsDisabled(false);
                toast.error(Utils.getErrorMessage(err));
            });
    };

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        let particles = [];
        let animationFrame;

        const initCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = 400; // Fixed height for footer
            createParticles();
        };

        const createParticles = () => {
            particles = [];
            const numberOfParticles = 50;

            for (let i = 0; i < numberOfParticles; i++) {
                particles.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    radius: Math.random() * 3 + 1,
                    dx: (Math.random() - 0.5) * 1,
                    dy: (Math.random() - 0.5) * 1,
                });
            }
        };

        const drawParticles = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';

            particles.forEach((particle, i) => {
                ctx.beginPath();
                ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
                ctx.fill();

                // Draw connections
                particles.forEach((particle2, j) => {
                    if (i !== j) {
                        const dx = particle.x - particle2.x;
                        const dy = particle.y - particle2.y;
                        const distance = Math.sqrt(dx * dx + dy * dy);

                        if (distance < 100) {
                            ctx.beginPath();
                            ctx.strokeStyle = `rgba(255, 255, 255, ${0.2 - distance / 500})`;
                            ctx.lineWidth = 0.5;
                            ctx.moveTo(particle.x, particle.y);
                            ctx.lineTo(particle2.x, particle2.y);
                            ctx.stroke();
                        }
                    }
                });

                // Update position
                particle.x += particle.dx;
                particle.y += particle.dy;

                // Bounce off walls
                if (particle.x < 0 || particle.x > canvas.width) particle.dx *= -1;
                if (particle.y < 0 || particle.y > canvas.height) particle.dy *= -1;
            });

            animationFrameRef.current = requestAnimationFrame(drawParticles);
        };

        const handleResize = () => {
            initCanvas();
        };

        window.addEventListener('resize', handleResize);
        initCanvas();
        drawParticles();

        return () => {
            window.removeEventListener('resize', handleResize);
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }
        };
    }, []);

    const exploreLinks = [
        {
            name: 'Product',
            link: '/product'
        },
        {
            name: 'Pricing',
            link: '/pricing'
        },
        {
            name: 'FAQ',
            link: '/faq'
        },
        {
            name: 'Contact Us',
            link: '/contact'
        },
        {
            name: 'Use Cases',
            link: '/use-cases'
        },
        {
            name: 'Blog',
            link: '/blog'
        },
    ];

    const resourceLinks = [
        {
            name: 'Privacy Policy',
            link: '/privacy-policy'
        },
        {
            name: 'Refund Policy',
            link: '/refund-policy'
        },
        {
            name: 'Customer Support',
            link: '/customer-support'
        },
        {
            name: 'Security',
            link: '/security'
        },
        {
            name: 'Terms and Conditions',
            link: '/terms-condition'
        },
    ]

    return (
        <>
            <div className="border-bottom border-top border-2 py-3 d-none d-lg-block guest_footer">
                <div className="container">
                    <ul className="d-flex justify-content-around mb-0">
                        <li className="border-end border-1 border-dark-subtle pe-4 d-none d-lg-block">
                            <TbHours24 className="me-2" size={20} />
                            <span className="text-dark fw-bold"> 24/7 support </span>
                        </li>
                        <li className="border-end border-1 border-dark-subtle pe-4 d-none d-lg-block">
                            <LiaCalendarWeekSolid size={20} className="me-2" />
                            <span className="text-dark fw-bold">Weekly updates</span>
                        </li>
                        <li className="border-end border-1 border-dark-subtle pe-4 d-none d-lg-block">
                            <GrSecure size={20} className="me-2" />
                            <span className="text-dark fw-bold">Secure and compliant</span>
                        </li>
                        <li className="border-0 d-none d-lg-block">
                            <IoMdSpeedometer size={20} className="me-2" />
                            <span className="text-dark fw-bold">99.9% uptime</span>
                        </li>
                    </ul>
                </div>
            </div>

            <footer className="text-white py-4 position-relative" style={{ backgroundColor: '#1e2875', overflow: 'hidden' }}>
                <canvas
                    ref={canvasRef}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        pointerEvents: 'none'
                    }}
                />
                <div className="container">
                    <div className="row border-bottom border-light pb-4">
                        {/* Logo and Description */}
                        <div className="col-lg-3 mb-4 mb-md-0 ">
                            <img src="images/Docusafe_logo.webp" alt="" className="docusafe_logo bg-white" />
                            <p className="text-light footer-content mt-3">
                                A system built to streamline the collection and management of large-scale document requests.
                            </p>
                        </div>

                        {/* Explore Section */}
                        <div className="col-lg-3 mb-4 mb-md-0 text-start">
                            <h5 className="text-uppercase mb-2">Explore</h5>
                            <p className="footer-content">
                                <ul className="list-unstyled">
                                    {exploreLinks.map((item, index) => (
                                        <li key={index} className="mb-2">
                                            <NavLink
                                                to={item.link}
                                                className="footer-link fs-6 text-white text-light text-decoration-none"
                                            >
                                                <IoIosArrowRoundForward className="icon fs-4 me-2 text-white" />
                                                {item.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </p>
                        </div>

                        {/* Resources Section */}
                        <div className="col-lg-3 mb-4 mb-md-0">
                            <h5 className="text-uppercase mb-2">Resources</h5>
                            <p className="text-light footer-content">
                                <ul className="list-unstyled">
                                    {resourceLinks.map((item, index) => (
                                        <li key={index} className="mb-2">
                                            <NavLink
                                                to={item.link}
                                                className="footer-link fs-6 text-white text-decoration-none"
                                            >
                                                <IoIosArrowRoundForward className="icon fs-4 me-2 text-white" />
                                                {item.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </p>
                        </div>

                        {/* Newsletter Section */}
                        <div className="col-lg-3 mb-4 mb-md-0">
                            <h5 className="text-uppercase">Newsletter</h5>
                            <p className="text-light footer-content">
                                Stay updated with our latest news and offers. Enter your email to subscribe!
                            </p>
                            <form className="mt-3" onSubmit={onSubmitNewsLetter}>
                                <div className="newsletter_form">
                                    <input
                                        type="email"
                                        value={email}
                                        placeholder="Email Address"
                                        className={`form-control me-2 mb-2 ${errors.email ? 'is-invalid' : ''}`}
                                        onChange={(e) => setEmail(e.target.value)}
                                        disabled={isDisabled}
                                    />
                                    {errors.email && <div className="text-danger mt-1">{errors.email}</div>}

                                    {isDisabled ? (
                                        <button
                                            className="btn my-2 py-1 px-3 home_btn border-0"
                                            disabled={true}
                                            type="button"
                                        >
                                            <i className="bi bi-arrow-repeat spinner-border "></i>
                                        </button>
                                    ) : (
                                        <button
                                            className="btn subscribe text-white border-2 border-white"
                                            type="submit"
                                        >
                                            Subscribe
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>

                    {/* Bottom Footer */}
                    <div className="text-center mt-4">
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="mb-0">
                                <span>Copyright {CURRENT_YEAR} @ <span className="text-white">DocuSafe.ai</span> All rights reserved</span>
                            </div>
                            <div className="alumni-highlight d-flex align-items-center justify-content-center px-3 py-2 my-2 mx-auto mx-lg-0" style={{
                                background: '#fff',
                                boxShadow: '0 4px 24px 0 rgba(79,140,255,0.15), 0 1.5px 8px 0 rgba(143,92,255,0.10)',
                                borderRadius: '6px',
                                border: 'none',
                                minWidth: '280px',
                                maxWidth: '100%',
                                fontWeight: 500,
                                color: '#222',
                                position: 'relative',
                                overflow: 'hidden',
                                letterSpacing: '0.01em'
                            }}>
                                <span>
                                    Made with <span role="img" aria-label="bulb">💡</span> by alumni of <a href="https://www.iima.ac.in/" target="_blank" rel="noopener noreferrer" style={{ fontWeight: 'bold', color: '#1976D2', textDecoration: 'underline' }}>IIM Ahmedabad</a> and <a href="https://www.bits-pilani.ac.in/" target="_blank" rel="noopener noreferrer" style={{ fontWeight: 'bold', color: '#1976D2', textDecoration: 'underline' }}>BITS Pilani</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default GuestFooter;